//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Object.js";
import "../no/BasePart.js";
import "../no/BasePart.js";
let d=[[],[[[],"CreateHideComponentBuilder",{R_:{builder:"Assemblies.HideComponentBuilder"}},0,0],[[],"CreateShowComponentBuilder",{R_:{builder:"Assemblies.ShowComponentBuilder"}},0,0],[[],"CreateUpdateStructureBuilder",{R_:{builder:"Assemblies.UpdateStructureBuilder"}},0,0],[[],"CreateReplaceComponentBuilder",{R_:{builder:"Assemblies.ReplaceComponentBuilder"}},0,0],[[],"CreateLoadInterpartDataBuilder",{R_:{builder:"Assemblies.LoadInterpartDataBuilder"}},0,0],[[],"CreateNewComponentBuilder",{R_:{builder:"Assemblies.CreateNewComponentBuilder"}},0,0],[[],"CreateConstraintDisplayBuilder",{R_:{builder:"Assemblies.ConstraintDisplayBuilder"}},0,0],[[],"CreateMakeUniquePartBuilder",{R_:{builder:"Assemblies.MakeUniquePartBuilder"}},0,0],[["clearanceSet"],"CreateClearanceAnalysisBuilder",{R_:{builder:"Assemblies.ClearanceAnalysisBuilder"}},1,0],[[],"CreateAddComponentBuilder",{R_:{builder:"Assemblies.AddComponentBuilder"}},0,0],[[],"CreateCreateComponentBuilder",{R_:{builder:"Assemblies.CreateComponentBuilder"}},0,0],[["sourcePart","destinationPartOcc"],"CreateReflectComponentBuilder",{R_:{builder:"Assemblies.ReflectComponentBuilder"}},2,0],[[],"CreateSimplifyBuilder",{R_:{builder:"Assemblies.SimplifyBuilder"}},0,0],[["contextComponent"],"CreateSimplifyBuilderWithContextComponent",{R_:{builder:"Assemblies.SimplifyBuilder"}},1,0],[["contextComponent"],"CreateLabelModelingComponentBuilder",{R_:{builder:"Assemblies.LabelModelingComponentBuilder"}},1,0],[[],"CreateOpenByProximityBuilder",{R_:{builder:"Assemblies.OpenByProximityBuilder"}},0,0]],[]];
SPLM.Assemblies.AssemblyManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Assemblies.AssemblyManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;